import { IconProps } from 'interfaces/common'

export const GoogleIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.7459 12.27C23.7459 11.48 23.6759 10.73 23.5559 10H12.2559V14.51H18.7259C18.4359 15.99 17.5859 17.24 16.3259 18.09V21.09H20.1859C22.4459 19 23.7459 15.92 23.7459 12.27Z"
        fill="#4285F4"
      />
      <path
        d="M12.2549 24C15.4949 24 18.2049 22.92 20.1849 21.09L16.3249 18.09C15.2449 18.81 13.8749 19.25 12.2549 19.25C9.12492 19.25 6.47492 17.14 5.52492 14.29H1.54492V17.38C3.51492 21.3 7.56492 24 12.2549 24Z"
        fill="#34A853"
      />
      <path
        d="M5.52586 14.29C5.27586 13.57 5.14586 12.8 5.14586 12C5.14586 11.2 5.28586 10.43 5.52586 9.71V6.62H1.54586C0.725858 8.24 0.255859 10.06 0.255859 12C0.255859 13.94 0.725858 15.76 1.54586 17.38L5.52586 14.29Z"
        fill="#FBBC05"
      />
      <path
        d="M12.2549 4.75C14.0249 4.75 15.6049 5.36 16.8549 6.55L20.2749 3.13C18.2049 1.19 15.4949 0 12.2549 0C7.56492 0 3.51492 2.7 1.54492 6.62L5.52492 9.71C6.47492 6.86 9.12492 4.75 12.2549 4.75Z"
        fill="#EA4335"
      />
    </svg>
  )
}

export const FacebookIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_8217_10905)">
        <path
          d="M24 12C24 5.37262 18.6274 0 12 0C5.37262 0 0 5.37262 0 12C0 17.9895 4.38825 22.954 10.125 23.8542V15.4688H7.07812V12H10.125V9.35625C10.125 6.34875 11.9166 4.6875 14.6576 4.6875C15.9705 4.6875 17.3438 4.92188 17.3438 4.92188V7.875H15.8306C14.3399 7.875 13.875 8.80003 13.875 9.74906V12H17.2031L16.6711 15.4688H13.875V23.8542C19.6117 22.954 24 17.9896 24 12Z"
          fill="#1877F2"
        />
        <path
          d="M16.6711 15.4688L17.2031 12H13.875V9.74906C13.875 8.79994 14.3399 7.875 15.8306 7.875H17.3438V4.92188C17.3438 4.92188 15.9705 4.6875 14.6575 4.6875C11.9166 4.6875 10.125 6.34875 10.125 9.35625V12H7.07812V15.4688H10.125V23.8542C10.7453 23.9514 11.3722 24.0002 12 24C12.6278 24.0002 13.2547 23.9514 13.875 23.8542V15.4688H16.6711Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_8217_10905">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const RecoveryIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="83"
      height="83"
      preserveAspectRatio="none"
      viewBox="0 0 2048 2048"
    >
      <defs>
        <linearGradient
          id="recoveryGradient1"
          x1="980.621"
          x2="698.065"
          y1="1030.02"
          y2="1485.28"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#325BFF" />
          <stop offset="1" stopColor="#0AF" />
        </linearGradient>
        <linearGradient
          id="recoveryGradient2"
          x1="1451.93"
          x2="1066.58"
          y1="603.037"
          y2="888.192"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#B82BFD" />
          <stop offset="1" stopColor="#5E55FE" />
        </linearGradient>
      </defs>
      <path
        fill="#FEFEFE"
        d="M1013.86 644.442c2.25-.044 4.5-.075 6.76-.094 61.7-.561 115.35 28.246 144.57 83.235 15.65 29.443 18.01 57.079 18.02 89.605-17.72.531-36.34-.297-54.29.033.42-30.385-2.79-56.563-22.74-81.149-50.08-61.695-140.309-52.424-175.282 19.438-11.089 22.785-10.429 44.055-10.555 68.813q-.093 26.875.107 53.751c.045 9.466.501 19.843-.5 29.209 71.75-1.852 151.4-.196 223.66-.139l75.68-.128c24.72-.064 66.68-7.161 67.99 27.342.93 24.812.67 49.655.7 74.492l.05 157.4c-.06 37.45 1.57 80.28-1.77 117.8-.28 3.21-10.02 15.49-13.32 16.26-20.57 4.87-48.17 2.76-69.84 2.74l-109.11-.08-309.026-.06c-12.563-7.3-20.086-12.89-20.163-28.84-.132-27.17-.236-54.34-.077-81.52l.192-126.87-.209-91.317c.025-19.045-6.389-63.551 20.755-65.917 26.151-2.279 54.438-1.371 80.893-1.37-.908-23.409-.18-47.1-.552-69.99-.869-53.442-.762-92.857 35.315-136.501 31.883-38.57 64.904-50.984 112.742-56.143M818.349 1253.08c96.568-1.62 196.911-.24 293.841-.22l80.4.01c11.25.01 31.6.72 41.84-.28 1.14-1.44.96-.78 1.13-1.73-1.52-96.79 1.35-195.13-.45-291.498-28.78.779-58.24.744-87.06.534-109.82-.801-219.956.903-329.735-.368 1.402 13.422.64 40.01.63 54.432l-.058 100.6.102 90.16c.013 11.75.672 37.53-.64 48.36"
      />
      <path
        fill="#FEFEFE"
        d="M1025.22 1039.52c23.47 1.01 43.48 14.35 52.97 35.81a57.47 57.47 0 0 1 .68 44.92c-4.74 11.65-15.61 25.83-27.28 30.69.31 27.34.33 54.67.05 82.01l-27.79-.06-27.176-.11c.47-12.27.145-26.2.328-38.74.174-11.98 1.119-29.64.021-41.08-4.968-3.34-9.663-6.46-14.153-10.44-24.241-21.45-28.128-60.79-4.802-84.52 14.273-14.52 27.362-17.82 47.152-18.48"
      />
      <path
        fill="url(#recoveryGradient2)"
        d="M690.687 523.484c10.972-9.074 43.283-26.742 56.379-33.539a592.34 592.34 0 0 1 333.304-63.921c155.24 14.673 298.37 90.146 398.16 209.952 136.19 165.107 168.17 408.284 81.07 602.814-4.94 11.02-12.77 29.45-19.33 39.32-26.81 49.49-58.17 91.74-97.52 131.87-3.39 3.45-18.17 18.4-21.84 20.39-1.23.02-3.51-.04-4.53.88-18.89 17.1-38.49 31.92-58.79 47.18-4.67-3.3-20.32-14.23-23.6-18.11 16.32-13.38 36.06-25.31 52.23-39.26 5.06-4.37 9.81-5.75 10.72-12.65.8-1.15 15.4-15.26 17.29-17.15a649 649 0 0 0 34.18-36.37 557 557 0 0 0 47.24-64.47c5.61-9.07 10.16-18.81 15.91-27.64l.64-.97c17.97-35.5 31.55-68.37 42.25-106.9a565 565 0 0 0-52.1-423.153c-68.45-120.709-191.82-215.141-325.45-252.127-150.28-41.594-301.06-24.198-436.816 53.178-1.324-.158-1.498-.372-2.766-.891 7.372-8.99 55.569-26.589 59.626-33.019-4.115-5.242-10.516-5.446-13.603-9.795-9.172-12.923-29.585-.217-40.599 5.457-14.396 7.416-29.966 17.548-43.873 26.199-3.304 2.056-4.418 3.67-8.182 2.725"
      />
      <path
        fill="#5D52FE"
        d="m1512.2 1261.81 2.21.52c20.4-36.74 35.46-81.81 46.61-122.21 3.87-14.05 7.81-18.95 9.52-34.66l2.45 1.94c6.78-4.66 2.57-19.01 17.29-16.59 3.34 2.59 2.09.98 3.64 5.2-1.79 9.94-7.98 13.11-3.62 28.53.53 1.93 1.07 3.86 1.63 5.79-6.47 8.38-1.9 15.71-5.52 25.4-5.33 14.29-8.91 29.45-14.14 43.82-8.33 21.41-21.68 56.89-33.18 75.95.77 2.14.3 1.32 1.18 2.61-26.81 49.49-58.17 91.74-97.52 131.87-3.39 3.45-18.17 18.4-21.84 20.39-1.23.02-3.51-.04-4.53.88-18.89 17.1-38.49 31.92-58.79 47.18-4.67-3.3-20.32-14.23-23.6-18.11 16.32-13.38 36.06-25.31 52.23-39.26 5.06-4.37 9.81-5.75 10.72-12.65.8-1.15 15.4-15.26 17.29-17.15a649 649 0 0 0 34.18-36.37 557 557 0 0 0 47.24-64.47c5.61-9.07 10.16-18.81 15.91-27.64z"
      />
      <path
        fill="url(#recoveryGradient1)"
        d="M1420.91 1430.37c-24.74 24.37-49.46 41.81-78.09 60.58-71.88 47.14-148.32 75.57-233.33 88.92-152.739 22.72-308.278-15.63-432.938-106.76-125.51-89.71-209.219-226.53-231.948-379.12a592.9 592.9 0 0 1 50.288-345.814c8.037-16.563 20.669-41.209 31.575-56.133-.643 11.069-40.585 68.595-41.759 87.202 2.272-1.306 2.162-1.479 3.758-3.63l1.917-.351c.579 3.036.323 2.069-.672 5.45 3.487-2.641 8.444-12.2 10.705-16.206l3.419-.565c2.731-2.786 14.942-18.169 18.531-17.696 2.52 3.472 1.943 4.019 5.1 4.709 6.157-6.858 10.34-23.963 19.107-27.329-19.058 33.772-34.655 64.948-46.66 101.694-83.335 255.079 17.795 528.899 255.664 658.139 129.211 70.2 270.883 85.48 413.653 48.89 89.65-23.65 157.6-65.11 227.71-123.94-.91 6.9-5.66 8.28-10.72 12.65-16.17 13.95-35.91 25.88-52.23 39.26 3.28 3.88 18.93 14.81 23.6 18.11 20.3-15.26 39.9-30.08 58.79-47.18 1.02-.92 3.3-.86 4.53-.88"
      />
      <path
        fill="#5D52FE"
        d="M690.687 523.484c3.764.945 4.878-.669 8.182-2.725 13.907-8.651 29.477-18.783 43.873-26.199 11.014-5.674 31.427-18.38 40.599-5.457 3.087 4.349 9.488 4.553 13.603 9.795-4.057 6.43-52.254 24.029-59.626 33.019 1.268.519 1.442.733 2.766.891-88 54.624-137.167 104.231-193.511 190.819-8.767 3.366-12.95 20.471-19.107 27.329-3.157-.69-2.58-1.237-5.1-4.709-3.589-.473-15.8 14.91-18.531 17.696l-3.419.565c-2.261 4.006-7.218 13.565-10.705 16.206.995-3.381 1.251-2.414.672-5.45l-1.917.351c-1.596 2.151-1.486 2.324-3.758 3.63 1.174-18.607 41.116-76.133 41.759-87.202 1.58-4.302 12.968-20.211 16.092-24.587 31.327-43.874 68.001-82.911 110.322-116.343 9.851-7.781 26.921-21.799 37.806-27.629"
      />
    </svg>
  )
}

export const MiniRecoveryIcon = () => {
  return (
    <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.87868 1.40993C4.44129 0.84732 5.20435 0.53125 6 0.53125C6.79565 0.53125 7.55871 0.84732 8.12132 1.40993C8.68393 1.97254 9 2.7356 9 3.53125V6H9.5C10.6046 6 11.5 6.89543 11.5 8V13.5C11.5 14.6046 10.6046 15.5 9.5 15.5H2.5C1.39543 15.5 0.5 14.6046 0.5 13.5V8C0.5 6.89543 1.39543 6 2.5 6H3V3.53125C3 2.7356 3.31607 1.97254 3.87868 1.40993ZM2.5 7C1.94772 7 1.5 7.44772 1.5 8V13.5C1.5 14.0523 1.94772 14.5 2.5 14.5H9.5C10.0523 14.5 10.5 14.0523 10.5 13.5V8C10.5 7.44772 10.0523 7 9.5 7H2.5ZM8 6H4V3.53125C4 3.00082 4.21071 2.49211 4.58579 2.11704C4.96086 1.74196 5.46957 1.53125 6 1.53125C6.53043 1.53125 7.03914 1.74196 7.41421 2.11704C7.78929 2.49211 8 3.00082 8 3.53125V6Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const FirstStartUpStep = (props: IconProps) => {
  return (
    <svg
      width="264"
      height="255"
      viewBox="0 0 264 255"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="264" height="255" />
      <path
        d="M37.8711 19.5938V85H22.7324V36.6641L7.81836 41.0215V29.5215L36.4785 19.5938H37.8711Z"
        fill="white"
      />
      <g filter="url(#filter0_d_3735_4256)">
        <rect
          x="33.5"
          y="51"
          width="188"
          height="188"
          rx="22"
          fill="#2B3D5A"
          shapeRendering="crispEdges"
        />
        <path d="M75.5 130H179" stroke="#0B2040" strokeWidth="16" strokeLinecap="round" />
        <path d="M105.5 94H149.5" stroke="#232C3A" strokeWidth="12" strokeLinecap="round" />
        <path d="M75.5 156.5H179" stroke="#0B2040" strokeWidth="16" strokeLinecap="round" />
        <path d="M75.5 195H179" stroke="#FFA127" strokeWidth="16" strokeLinecap="round" />
      </g>
      <path
        d="M254.057 244.458C254.057 245.415 253.306 246.167 252.349 246.167H193.651C192.694 246.167 191.942 245.415 191.942 244.458C191.942 230.313 205.882 218.833 223 218.833C226.519 218.833 229.936 219.312 233.079 220.234C231.063 222.626 229.833 225.735 229.833 229.083C229.833 231.646 230.551 234.072 231.815 236.122C232.498 237.283 233.387 238.342 234.412 239.231C236.803 241.417 239.981 242.75 243.5 242.75C247.327 242.75 250.777 241.178 253.237 238.65C253.784 240.495 254.057 242.442 254.057 244.458Z"
        fill="#23B580"
      />
      <path
        d="M253.647 219.961C251.187 217.159 247.531 215.417 243.5 215.417C239.673 215.417 236.188 216.988 233.694 219.551C231.302 222.011 229.833 225.393 229.833 229.083C229.833 231.646 230.55 234.072 231.815 236.122C232.498 237.283 233.386 238.342 234.411 239.231C236.803 241.417 239.981 242.75 243.5 242.75C248.488 242.75 252.827 240.085 255.185 236.122C255.902 234.96 256.449 233.627 256.756 232.261C257.03 231.236 257.166 230.177 257.166 229.083C257.166 225.598 255.834 222.387 253.647 219.961ZM248.625 231.577H246.062V234.243C246.062 235.643 244.901 236.805 243.5 236.805C242.099 236.805 240.937 235.643 240.937 234.243V231.577H238.375C236.974 231.577 235.812 230.416 235.812 229.015C235.812 227.614 236.974 226.452 238.375 226.452H240.937V224.027C240.937 222.626 242.099 221.464 243.5 221.464C244.901 221.464 246.062 222.626 246.062 224.027V226.452H248.625C250.026 226.452 251.187 227.614 251.187 229.015C251.187 230.416 250.026 231.577 248.625 231.577Z"
        fill="#1C7655"
      />
      <path
        d="M223 212C232.435 212 240.084 204.352 240.084 194.917C240.084 185.482 232.435 177.833 223 177.833C213.565 177.833 205.917 185.482 205.917 194.917C205.917 204.352 213.565 212 223 212Z"
        fill="#1C7655"
      />
      <defs>
        <filter
          id="filter0_d_3735_4256"
          x="23.8"
          y="41.3"
          width="207.4"
          height="207.4"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4.85" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3735_4256" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3735_4256"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export const SecondStartUpStep = (props: IconProps) => {
  return (
    <svg
      width="258"
      height="257"
      viewBox="0 0 258 257"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_3735_4267)">
        <rect width="257.75" height="257" transform="translate(0.125)" />
        <path
          d="M50.125 73.3203V85H4.48438V75.1172L25.5078 53.0156C27.3646 50.8893 28.862 48.9876 30 47.3105C31.138 45.6035 31.9616 44.0612 32.4707 42.6836C33.0098 41.306 33.2793 40.0632 33.2793 38.9551C33.2793 37.0684 32.9948 35.4961 32.4258 34.2383C31.8867 32.9505 31.0781 31.9772 30 31.3184C28.9518 30.6595 27.6491 30.3301 26.0918 30.3301C24.5345 30.3301 23.1719 30.7793 22.0039 31.6777C20.8359 32.5762 19.9225 33.804 19.2637 35.3613C18.6348 36.9186 18.3203 38.6706 18.3203 40.6172H3.13672C3.13672 36.6042 4.11003 32.9355 6.05664 29.6113C8.0332 26.2871 10.7734 23.6367 14.2773 21.6602C17.7812 19.6536 21.8392 18.6504 26.4512 18.6504C31.2728 18.6504 35.3158 19.3991 38.5801 20.8965C41.8444 22.3939 44.3001 24.5651 45.9473 27.4102C47.6243 30.2253 48.4629 33.6243 48.4629 37.6074C48.4629 39.8835 48.1035 42.0697 47.3848 44.166C46.666 46.2624 45.6328 48.3438 44.2852 50.4102C42.9375 52.4466 41.2904 54.543 39.3438 56.6992C37.4271 58.8555 35.2409 61.1465 32.7852 63.5723L24.3398 73.3203H50.125Z"
          fill="white"
        />
        <g filter="url(#filter0_d_3735_4267)">
          <rect
            x="34.625"
            y="53"
            width="188"
            height="188"
            rx="22"
            fill="#2B3D5A"
            shapeRendering="crispEdges"
          />
          <path
            d="M50.9644 189.768L74.1346 146.283L95.5155 162.661L120.918 148.615L139.379 170.907L147.726 113.158"
            stroke="#0288FF"
            strokeWidth="12"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M177.125 159L207.125 159"
            stroke="#FC6775"
            strokeWidth="16"
            strokeLinecap="round"
          />
          <path
            d="M177.125 135L207.125 135"
            stroke="#3DBE8F"
            strokeWidth="16"
            strokeLinecap="round"
          />
          <path
            d="M177.125 91L207.125 91"
            stroke="white"
            strokeOpacity="0.2"
            strokeWidth="16"
            strokeLinecap="round"
          />
          <path
            d="M177.125 69L207.125 69"
            stroke="white"
            strokeOpacity="0.2"
            strokeWidth="16"
            strokeLinecap="round"
          />
          <path
            d="M103.125 69L155.125 69"
            stroke="white"
            strokeOpacity="0.2"
            strokeWidth="16"
            strokeLinecap="round"
          />
          <path
            d="M51.125 69H81.125"
            stroke="white"
            strokeOpacity="0.2"
            strokeWidth="16"
            strokeLinecap="round"
          />
        </g>
        <path
          d="M235.771 197.087C234.951 196.951 234.097 196.917 233.209 196.917H199.042C198.085 196.917 197.163 196.985 196.274 197.122C196.753 196.165 197.436 195.277 198.256 194.457L209.36 183.318C214.041 178.672 221.626 178.672 226.307 183.318L232.286 189.366C234.473 191.518 235.634 194.252 235.771 197.087Z"
          fill="#1C7655"
        />
        <circle cx="192.125" cy="238" r="13" fill="white" />
        <path
          d="M192.209 224.25C184.658 224.25 178.542 230.366 178.542 237.917C178.542 240.479 179.259 242.905 180.524 244.955C182.881 248.918 187.22 251.583 192.209 251.583C197.197 251.583 201.536 248.918 203.894 244.955C205.158 242.905 205.875 240.479 205.875 237.917C205.875 230.366 199.759 224.25 192.209 224.25ZM197.299 240.411H194.771V243.076C194.771 244.477 193.609 245.638 192.209 245.638C190.808 245.638 189.646 244.477 189.646 243.076V240.411H187.118C185.717 240.411 184.555 239.249 184.555 237.848C184.555 236.447 185.717 235.286 187.118 235.286H189.646V232.86C189.646 231.459 190.808 230.298 192.209 230.298C193.609 230.298 194.771 231.459 194.771 232.86V235.286H197.299C198.7 235.286 199.862 236.447 199.862 237.848C199.862 239.249 198.734 240.411 197.299 240.411Z"
          fill="#1C7655"
        />
        <path
          d="M250.291 214V231.083C250.291 241.333 243.458 248.167 233.208 248.167H201.194C202.253 247.278 203.176 246.185 203.893 244.955C205.157 242.905 205.875 240.479 205.875 237.917C205.875 230.366 199.759 224.25 192.208 224.25C188.108 224.25 184.452 226.061 181.958 228.897V214C181.958 204.707 187.561 198.215 196.274 197.122C197.162 196.985 198.085 196.917 199.041 196.917H233.208C234.096 196.917 234.951 196.951 235.771 197.087C244.586 198.112 250.291 204.638 250.291 214Z"
          fill="#23B580"
        />
        <path
          d="M250.291 215.708H240.041C236.283 215.708 233.208 218.783 233.208 222.542C233.208 226.3 236.283 229.375 240.041 229.375H250.291"
          fill="#1C7655"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_3735_4267"
          x="18.625"
          y="37"
          width="220"
          height="220"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3735_4267" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3735_4267"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_3735_4267">
          <rect width="257.75" height="257" fill="white" transform="translate(0.125)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const ThirdStartUpStep = (props: IconProps) => {
  return (
    <svg
      width="258"
      height="257"
      viewBox="0 0 258 257"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_3735_4276)">
        <rect width="257.5" height="257" transform="translate(0.25)" />
        <path
          d="M18.4004 45.9629H25.7676C27.6543 45.9629 29.1966 45.6335 30.3945 44.9746C31.6224 44.2858 32.5358 43.3275 33.1348 42.0996C33.7337 40.8418 34.0332 39.3594 34.0332 37.6523C34.0332 36.3346 33.7487 35.1217 33.1797 34.0137C32.6406 32.9056 31.8021 32.0221 30.6641 31.3633C29.526 30.6745 28.0736 30.3301 26.3066 30.3301C25.1087 30.3301 23.9408 30.5846 22.8027 31.0938C21.6647 31.5729 20.7214 32.2617 19.9727 33.1602C19.2539 34.0586 18.8945 35.1517 18.8945 36.4395H3.71094C3.71094 32.7259 4.72917 29.5514 6.76562 26.916C8.83203 24.2507 11.5423 22.2142 14.8965 20.8066C18.2806 19.3691 21.9193 18.6504 25.8125 18.6504C30.4544 18.6504 34.5273 19.3691 38.0312 20.8066C41.5352 22.2142 44.2604 24.3105 46.207 27.0957C48.1836 29.8509 49.1719 33.265 49.1719 37.3379C49.1719 39.584 48.6478 41.6953 47.5996 43.6719C46.5514 45.6484 45.084 47.3854 43.1973 48.8828C41.3105 50.3802 39.0944 51.5632 36.5488 52.4316C34.0332 53.2702 31.278 53.6895 28.2832 53.6895H18.4004V45.9629ZM18.4004 57.2383V49.6914H28.2832C31.5475 49.6914 34.5273 50.0658 37.2227 50.8145C39.918 51.5332 42.2389 52.6113 44.1855 54.0488C46.1322 55.4863 47.6296 57.2682 48.6777 59.3945C49.7259 61.4909 50.25 63.9017 50.25 66.627C50.25 69.6816 49.6361 72.4069 48.4082 74.8027C47.1803 77.1986 45.4583 79.2201 43.2422 80.8672C41.026 82.5143 38.4355 83.7721 35.4707 84.6406C32.5059 85.4792 29.2865 85.8984 25.8125 85.8984C23.0872 85.8984 20.362 85.5391 17.6367 84.8203C14.9115 84.0716 12.4258 82.9336 10.1797 81.4062C7.93359 79.849 6.12174 77.8724 4.74414 75.4766C3.39648 73.0508 2.72266 70.1608 2.72266 66.8066H17.9062C17.9062 68.1842 18.2806 69.4421 19.0293 70.5801C19.8079 71.6882 20.8411 72.5716 22.1289 73.2305C23.4167 73.8893 24.8092 74.2188 26.3066 74.2188C28.1634 74.2188 29.7357 73.8743 31.0234 73.1855C32.3411 72.4668 33.3444 71.5085 34.0332 70.3105C34.722 69.1126 35.0664 67.7799 35.0664 66.3125C35.0664 64.0964 34.6921 62.3294 33.9434 61.0117C33.2246 59.694 32.1615 58.7357 30.7539 58.1367C29.3763 57.5378 27.7142 57.2383 25.7676 57.2383H18.4004Z"
          fill="white"
        />
        <g filter="url(#filter0_d_3735_4276)">
          <rect
            x="34.75"
            y="53"
            width="188"
            height="188"
            rx="22"
            fill="#2B3D5A"
            shapeRendering="crispEdges"
          />
          <path
            d="M59 81L119 81"
            stroke="white"
            strokeOpacity="0.2"
            strokeWidth="16"
            strokeLinecap="round"
          />
          <path
            d="M58 107L201 107"
            stroke="white"
            strokeOpacity="0.2"
            strokeWidth="16"
            strokeLinecap="round"
          />
          <path
            d="M142 81L202 81"
            stroke="white"
            strokeOpacity="0.2"
            strokeWidth="16"
            strokeLinecap="round"
          />
          <path
            d="M152.708 131H186.75C196.829 131 205 139.171 205 149.25V149.25C205 159.329 196.829 167.5 186.75 167.5H71.75C61.9469 167.5 54 175.447 54 185.25V185.25C54 195.053 61.9469 203 71.75 203H108.066"
            stroke="white"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="16 16"
          />
          <path d="M101 131H157" stroke="#3DBE8F" strokeWidth="16" strokeLinecap="round" />
          <path
            d="M135.269 181.381V190.406H131.706V181.381C131.706 180.74 131.136 180.431 130.756 180.431C130.637 180.431 130.519 180.455 130.4 180.503L111.566 187.604C110.307 188.079 109.5 189.266 109.5 190.62V192.211C107.339 193.826 105.938 196.415 105.938 199.336V190.62C105.938 187.794 107.671 185.276 110.307 184.279L129.165 177.154C129.687 176.964 130.234 176.869 130.756 176.869C133.131 176.869 135.269 178.793 135.269 181.381Z"
            fill="#3B5172"
          />
          <path
            d="M151.063 206.438V208.812C151.063 209.454 150.564 209.976 149.899 210H146.431C145.173 210 144.033 209.074 143.938 207.839C143.866 207.103 144.151 206.414 144.626 205.939C145.054 205.487 145.648 205.25 146.289 205.25H149.875C150.564 205.274 151.063 205.796 151.063 206.438Z"
            fill="#3B5172"
          />
          <path
            d="M146.265 202.756H148.688C149.994 202.756 151.062 201.688 151.062 200.381V199.336C151.062 194.42 147.049 190.406 142.132 190.406H114.868C112.849 190.406 110.996 191.071 109.5 192.211C107.339 193.826 105.938 196.415 105.938 199.336V215.32C105.938 220.236 109.951 224.25 114.868 224.25H142.132C147.049 224.25 151.062 220.236 151.062 215.32V214.869C151.062 213.562 149.994 212.494 148.688 212.494H146.621C144.341 212.494 142.156 211.092 141.562 208.884C141.064 207.079 141.658 205.345 142.845 204.181C143.724 203.279 144.935 202.756 146.265 202.756ZM133.25 202.281H116.625C115.651 202.281 114.844 201.474 114.844 200.5C114.844 199.526 115.651 198.719 116.625 198.719H133.25C134.224 198.719 135.031 199.526 135.031 200.5C135.031 201.474 134.224 202.281 133.25 202.281Z"
            fill="#3B5172"
          />
        </g>
        <path
          d="M209.382 234.432C224.459 234.432 236.681 222.209 236.681 207.132C236.681 192.056 224.459 179.833 209.382 179.833C194.305 179.833 182.083 192.056 182.083 207.132C182.083 222.209 194.305 234.432 209.382 234.432Z"
          fill="#23B580"
        />
        <path
          d="M250.314 227.633C250.314 238.908 241.157 248.064 229.882 248.064C222.912 248.064 216.796 244.579 213.106 239.283C228.003 237.609 239.859 225.753 241.533 210.857C246.829 214.547 250.314 220.663 250.314 227.633Z"
          fill="#1C7655"
        />
        <path
          d="M214.371 206.176L206.171 203.306C205.351 203.032 205.18 202.964 205.18 201.768C205.18 200.88 205.795 200.162 206.581 200.162H211.706C212.799 200.162 213.687 201.153 213.687 202.383C213.687 203.784 214.849 204.946 216.25 204.946C217.651 204.946 218.812 203.784 218.812 202.383C218.812 198.454 215.771 195.242 211.979 195.072V194.901C211.979 193.5 210.817 192.338 209.416 192.338C208.016 192.338 206.854 193.466 206.854 194.901V195.072H206.546C202.959 195.072 200.021 198.078 200.021 201.802C200.021 205.048 201.456 207.132 204.428 208.157L212.662 211.027C213.482 211.301 213.653 211.369 213.653 212.565C213.653 213.453 213.038 214.171 212.252 214.171H207.127C206.034 214.171 205.146 213.18 205.146 211.95C205.146 210.549 203.984 209.387 202.583 209.387C201.182 209.387 200.021 210.549 200.021 211.95C200.021 215.879 203.061 219.091 206.854 219.262V219.467C206.854 220.867 208.016 222.029 209.416 222.029C210.817 222.029 211.979 220.867 211.979 219.467V219.296H212.286C215.874 219.296 218.812 216.289 218.812 212.565C218.812 209.319 217.343 207.235 214.371 206.176Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_3735_4276"
          x="18.75"
          y="37"
          width="220"
          height="220"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3735_4276" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3735_4276"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_3735_4276">
          <rect width="257.5" height="257" fill="white" transform="translate(0.25)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const OwnAccIcon = (props: IconProps) => {
  return (
    <svg
      width="67"
      height="66"
      viewBox="0 0 67 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M62.1316 32.2504V6.881C62.1316 5.53533 61.5992 4.24477 60.6517 3.29323C59.7041 2.3417 58.419 1.80713 57.0789 1.80713H6.55263C5.21259 1.80713 3.92743 2.3417 2.97988 3.29323C2.03233 4.24477 1.5 5.53533 1.5 6.881V57.6197C1.5 58.9654 2.03233 60.256 2.97988 61.2075C3.92743 62.159 5.21259 62.6936 6.55263 62.6936H31.8158M57.1632 47.472V64.3849M65.5 55.8439H48.6579"
        stroke="#FFA127"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.8166 30.5609C36.4674 30.5609 40.2376 26.7748 40.2376 22.1044C40.2376 17.434 36.4674 13.6479 31.8166 13.6479C27.1657 13.6479 23.3955 17.434 23.3955 22.1044C23.3955 26.7748 27.1657 30.5609 31.8166 30.5609Z"
        stroke="#FFA127"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.974 44.0904C46.974 36.6183 40.1866 30.5601 31.8161 30.5601C23.4456 30.5601 16.6582 36.6183 16.6582 44.0904"
        stroke="#FFA127"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const IntuitInterfaceIcon = (props: IconProps) => {
  return (
    <svg
      width="65"
      height="65"
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_6033_2832)">
        <path
          d="M24.5 44.3848C25.6046 44.3848 26.5 43.4893 26.5 42.3848C26.5 41.2802 25.6046 40.3848 24.5 40.3848C23.3954 40.3848 22.5 41.2802 22.5 42.3848C22.5 43.4893 23.3954 44.3848 24.5 44.3848Z"
          fill="#FFA127"
        />
        <path
          d="M46.5 50.3848H18.5C16.294 50.3848 14.5 48.5908 14.5 46.3848V38.3848C14.5 36.1788 16.294 34.3848 18.5 34.3848H46.5C48.706 34.3848 50.5 36.1788 50.5 38.3848V46.3848C50.5 48.5908 48.706 50.3848 46.5 50.3848ZM18.5 38.3848V46.3848H46.5V38.3848H18.5Z"
          fill="#FFA127"
        />
        <path
          d="M24.5 24.3848C25.6046 24.3848 26.5 23.4893 26.5 22.3848C26.5 21.2802 25.6046 20.3848 24.5 20.3848C23.3954 20.3848 22.5 21.2802 22.5 22.3848C22.5 23.4893 23.3954 24.3848 24.5 24.3848Z"
          fill="#FFA127"
        />
        <path
          d="M46.5 30.3848H18.5C16.294 30.3848 14.5 28.5908 14.5 26.3848V18.3848C14.5 16.1788 16.294 14.3848 18.5 14.3848H46.5C48.706 14.3848 50.5 16.1788 50.5 18.3848V26.3848C50.5 28.5908 48.706 30.3848 46.5 30.3848ZM18.5 18.3848V26.3848H46.5V18.3848H18.5Z"
          fill="#FFA127"
        />
        <path
          d="M56.5 60.3848H8.5C6.294 60.3848 4.5 58.5908 4.5 56.3848V32.3848H8.5V56.3848H56.5V8.38477H32.5V4.38477H56.5C58.706 4.38477 60.5 6.17877 60.5 8.38477V56.3848C60.5 58.5908 58.706 60.3848 56.5 60.3848ZM24.5 0.384766V10.3848H20.5V0.384766H24.5ZM7.328 4.38477L14.4 11.4568L11.572 14.2848L4.5 7.21277L7.328 4.38477ZM0.5 20.3848H10.5V24.3848H0.5V20.3848Z"
          fill="#FFA127"
        />
      </g>
      <defs>
        <clipPath id="clip0_6033_2832">
          <rect width="64" height="64" fill="white" transform="translate(0.5 0.384766)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const PlanetIcon = () => {
  return (
    <svg width="81" height="81" viewBox="0 0 81 81" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M40.1497 73.7184C58.5592 73.7184 73.4831 58.7945 73.4831 40.385C73.4831 21.9755 58.5592 7.05176 40.1497 7.05176C21.7402 7.05176 6.81641 21.9755 6.81641 40.385C6.81641 58.7945 21.7402 73.7184 40.1497 73.7184Z"
        stroke="#FFA127"
        strokeWidth="2"
      />
      <path
        d="M10.1494 52.0272C14.5359 53.7862 17.6937 53.7862 19.6226 52.0272C22.5159 49.3887 20.0192 41.3809 24.0714 39.1724C28.1234 36.9639 34.2971 46.7535 40.0674 43.5324C45.8376 40.311 39.5237 31.7217 43.5281 28.2395C47.5324 24.7574 52.7394 28.6845 53.6496 22.862C54.5597 17.0396 49.4029 19.5649 48.4134 14.0627C47.7536 10.3947 47.7536 8.46592 48.4134 8.27637"
        stroke="#FFA127"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M48.5178 72.6357C45.3943 69.439 44.2698 66.4677 45.1444 63.7214C46.4564 59.602 48.6206 59.8455 49.5643 57.2985C50.5078 54.7514 47.8423 51.1237 53.7568 48.0225C57.6998 45.955 63.1213 48.3505 70.0209 55.2089"
        stroke="#FFA127"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}

export const CloseIcon = (props: IconProps) => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11 0.5C4.87143 0.5 0 5.37143 0 11.5C0 17.6286 4.87143 22.5 11 22.5C17.1286 22.5 22 17.6286 22 11.5C22 5.37143 17.1286 0.5 11 0.5ZM15.2429 17L11 12.7571L6.75714 17L5.5 15.7429L9.74286 11.5L5.5 7.25714L6.75714 6L11 10.2429L15.2429 6L16.5 7.25714L12.2571 11.5L16.5 15.7429L15.2429 17Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const EmailIcon = (props: IconProps) => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_5540_38514)">
        <path
          d="M0.526316 0.631579V0.105263C0.386728 0.105263 0.252858 0.160714 0.154154 0.259417C0.0554511 0.358121 0 0.491991 0 0.631579H0.526316ZM19.4737 0.631579H20C20 0.491991 19.9445 0.358121 19.8458 0.259417C19.7471 0.160714 19.6133 0.105263 19.4737 0.105263V0.631579ZM0.526316 1.15789H19.4737V0.105263H0.526316V1.15789ZM18.9474 0.631579V13.2632H20V0.631579H18.9474ZM17.3684 14.8421H2.63158V15.8947H17.3684V14.8421ZM1.05263 13.2632V0.631579H0V13.2632H1.05263ZM2.63158 14.8421C2.21282 14.8421 1.8112 14.6758 1.51509 14.3796C1.21898 14.0835 1.05263 13.6819 1.05263 13.2632H0C0 13.9611 0.277255 14.6304 0.770772 15.124C1.26429 15.6175 1.93364 15.8947 2.63158 15.8947V14.8421ZM18.9474 13.2632C18.9474 13.6819 18.781 14.0835 18.4849 14.3796C18.1888 14.6758 17.7872 14.8421 17.3684 14.8421V15.8947C18.0664 15.8947 18.7357 15.6175 19.2292 15.124C19.7227 14.6304 20 13.9611 20 13.2632H18.9474Z"
          fill="currentColor"
        />
        <path
          d="M0.526306 0.631577L9.99999 10.1053L19.4737 0.631577"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5540_38514">
          <rect width="20" height="15.7895" fill="white" transform="translate(0 0.105263)" />
        </clipPath>
      </defs>
    </svg>
  )
}
export const TimesRoundIcon = (props: IconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8492 0.0213562C13.1272 0.163731 15.2628 1.30273 16.8289 2.86886C18.6798 4.8621 19.6764 7.28248 19.6764 10.13C19.6764 12.408 18.8222 14.5436 17.3984 16.3945C15.9747 18.103 13.9814 19.3843 11.7034 19.8115C9.42542 20.2386 7.14742 19.9538 5.15417 18.8148C3.16092 17.6759 1.5948 15.9674 0.740548 13.8317C-0.113702 11.6961 -0.256077 9.27573 0.455798 7.1401C1.16767 4.8621 2.44905 3.01123 4.4423 1.72986C6.29317 0.448481 8.57117 -0.121019 10.8492 0.0213562ZM11.561 18.3877C13.4119 17.9606 15.1204 16.964 16.4018 15.3979C17.5408 13.8317 18.2527 11.9809 18.1103 9.9876C18.1103 7.7096 17.256 5.4316 15.6899 3.86548C14.2662 2.44173 12.5577 1.58748 10.5644 1.44511C8.71354 1.30273 6.72029 1.72986 5.15417 2.86886C3.58805 4.00786 2.44905 5.57398 1.87955 7.56723C1.31005 9.4181 1.31005 11.4114 2.1643 13.2622C3.01855 15.1131 4.29992 16.5369 6.00842 17.5335C7.71692 18.5301 9.71017 18.8148 11.561 18.3877ZM9.85254 9.27573L13.2695 5.71635L14.2662 6.71298L10.8492 10.2724L14.2662 13.8317L13.2695 14.8284L9.85254 11.269L6.43555 14.8284L5.43892 13.8317L8.85592 10.2724L5.43892 6.71298L6.43555 5.71635L9.85254 9.27573Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const ErrorIcon = (props: IconProps) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.8439 19.2779H2.97599C2.45193 19.2779 1.94932 19.0697 1.57875 18.6992C1.20818 18.3286 1 17.826 1 17.3019V3.46999C1 2.94592 1.20818 2.44332 1.57875 2.07275C1.94932 1.70218 2.45193 1.494 2.97599 1.494H18.7839C19.308 1.494 19.8106 1.70218 20.1812 2.07275C20.5517 2.44332 20.7599 2.94592 20.7599 3.46999V13.3499"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M1 5.44597H20.7599M3.96399 3.47986L3.97387 3.46899M6.92798 3.47986L6.93786 3.46899M9.89196 3.47986L9.90184 3.46899M16.8079 20.506L18.9035 18.4095M18.9035 18.4095L21 16.3139M18.9035 18.4095L16.8079 16.3139M18.9035 18.4095L21 20.506"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export const WiFiIcon = (props: IconProps) => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_5540_38565)">
        <path
          d="M3.3837 9.73883C4.51034 8.8221 5.81572 8.1503 7.21652 7.76628M12.8306 7.75935C14.242 8.14273 15.5572 8.81803 16.6912 9.74161M10 11.7724L10.0374 0.682831M0 6.4591C2.06237 4.68264 4.56362 3.49209 7.24286 3.01164M12.9082 3.03936C15.5313 3.53706 17.9772 4.71649 20 6.4591M6.72027 13.0297C6.94344 12.8744 7.17494 12.7372 7.41336 12.6166M12.5506 12.5944C12.8043 12.7192 13.051 12.8647 13.2894 13.0297"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.99999 17.3172C10.7656 17.3172 11.3862 16.6965 11.3862 15.931C11.3862 15.1654 10.7656 14.5448 9.99999 14.5448C9.23442 14.5448 8.6138 15.1654 8.6138 15.931C8.6138 16.6965 9.23442 17.3172 9.99999 17.3172Z"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5540_38565">
          <rect width="20" height="16.6343" fill="white" transform="translate(0 0.682831)" />
        </clipPath>
      </defs>
    </svg>
  )
}
export const RefreshIcon = (props: IconProps) => {
  return (
    <svg
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.30867 7.1068C3.1783 7.07231 3.05711 7.00959 2.95366 6.92308C2.85022 6.83658 2.76705 6.72839 2.71004 6.60618C2.65303 6.48397 2.62358 6.35073 2.62377 6.21588C2.62395 6.08103 2.65378 5.94787 2.71112 5.82582L4.74793 1.4884C4.82212 1.32956 4.94013 1.19522 5.08808 1.10118C5.23603 1.00714 5.40776 0.957324 5.58307 0.957582C5.75837 0.957839 5.92996 1.00817 6.07763 1.10264C6.2253 1.19711 6.34292 1.3318 6.41664 1.49085L7.3148 3.416C7.34687 3.40314 7.37965 3.39208 7.41296 3.38287C9.53198 2.81535 11.7788 2.96037 13.8073 3.79559C15.8358 4.6308 17.5334 6.10986 18.6385 8.00489C19.7435 9.89991 20.1948 12.1057 19.9228 14.2825C19.6508 16.4593 18.6705 18.4862 17.133 20.051C15.5955 21.6158 13.5862 22.6316 11.4145 22.9419C9.24289 23.2522 7.02946 22.8398 5.11528 21.7682C3.2011 20.6967 1.69238 19.0254 0.821597 17.0119C-0.0491917 14.9984 -0.233735 12.7545 0.2964 10.6258C0.325726 10.5085 0.377869 10.3981 0.449853 10.301C0.521837 10.2038 0.612251 10.1218 0.715933 10.0596C0.819616 9.99738 0.934536 9.95621 1.05413 9.93841C1.17373 9.92061 1.29566 9.92655 1.41296 9.95587C1.53027 9.9852 1.64065 10.0373 1.7378 10.1093C1.83495 10.1813 1.91697 10.2717 1.97918 10.3754C2.04139 10.4791 2.08257 10.594 2.10036 10.7136C2.11816 10.8332 2.11223 10.9551 2.0829 11.0724C1.65298 12.8002 1.8 14.6212 2.50151 16.2576C3.20303 17.894 4.42054 19.2561 5.96835 20.136C7.51616 21.016 9.30931 21.3655 11.0743 21.1313C12.8393 20.8971 14.4792 20.092 15.744 18.8388C17.0087 17.5857 17.8289 15.9532 18.0793 14.1905C18.3298 12.4277 17.9968 10.6314 17.1312 9.07558C16.2655 7.51973 14.9147 6.28972 13.2848 5.57316C11.6549 4.8566 9.83541 4.69282 8.10375 5.1068L9.01173 7.04913C9.08606 7.20776 9.11356 7.38431 9.09101 7.55804C9.06846 7.73176 8.9968 7.89544 8.88443 8.02984C8.77207 8.16424 8.62368 8.26377 8.4567 8.31674C8.28971 8.36972 8.11108 8.37393 7.94179 8.32888L3.30867 7.1068Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const BanIcon = (props: IconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.44828 3.79309C3.44828 3.52139 3.50179 3.25235 3.60577 3.00134C3.70974 2.75032 3.86214 2.52224 4.05426 2.33011C4.24638 2.13799 4.47446 1.98559 4.72548 1.88162C4.9765 1.77764 5.24554 1.72413 5.51724 1.72413C5.78894 1.72413 6.05798 1.77764 6.309 1.88162C6.56002 1.98559 6.7881 2.13799 6.98022 2.33011C7.17234 2.52224 7.32474 2.75032 7.42872 3.00134C7.53269 3.25235 7.58621 3.52139 7.58621 3.79309C7.58621 4.34182 7.36823 4.86807 6.98022 5.25607C6.59222 5.64408 6.06597 5.86206 5.51724 5.86206C4.96852 5.86206 4.44227 5.64408 4.05426 5.25607C3.66626 4.86807 3.44828 4.34182 3.44828 3.79309ZM5.51724 0.344818C4.6027 0.344818 3.72562 0.708118 3.07894 1.35479C2.43227 2.00147 2.06897 2.87855 2.06897 3.79309C2.06897 4.70763 2.43227 5.58472 3.07894 6.23139C3.72562 6.87807 4.6027 7.24137 5.51724 7.24137C6.43178 7.24137 7.30886 6.87807 7.95554 6.23139C8.60222 5.58472 8.96552 4.70763 8.96552 3.79309C8.96552 2.87855 8.60222 2.00147 7.95554 1.35479C7.30886 0.708118 6.43178 0.344818 5.51724 0.344818ZM12.4138 4.48275C12.4138 4.11693 12.5591 3.7661 12.8178 3.50743C13.0765 3.24876 13.4273 3.10344 13.7931 3.10344C14.1589 3.10344 14.5098 3.24876 14.7684 3.50743C15.0271 3.7661 15.1724 4.11693 15.1724 4.48275C15.1724 4.84857 15.0271 5.1994 14.7684 5.45807C14.5098 5.71674 14.1589 5.86206 13.7931 5.86206C13.4273 5.86206 13.0765 5.71674 12.8178 5.45807C12.5591 5.1994 12.4138 4.84857 12.4138 4.48275ZM11.6166 6.1793C12.3228 5.96838 13.056 5.86151 13.7931 5.86206C14.5302 5.86151 15.2634 5.96838 15.9697 6.1793C16.2872 5.77179 16.484 5.28329 16.5376 4.76942C16.5911 4.25555 16.4993 3.73697 16.2725 3.27275C16.0457 2.80852 15.6932 2.41731 15.2549 2.14366C14.8167 1.87 14.3104 1.72492 13.7938 1.72492C13.2771 1.72492 12.7709 1.87 12.3326 2.14366C11.8944 2.41731 11.5419 2.80852 11.3151 3.27275C11.0883 3.73697 10.9965 4.25555 11.05 4.76942C11.1036 5.28329 11.3003 5.77179 11.6179 6.1793M2.06897 8.62068H7.94069C7.58943 9.04618 7.28557 9.50868 7.03448 9.99999H2.06897C1.88606 9.99999 1.71064 10.0726 1.58131 10.202C1.45197 10.3313 1.37931 10.5067 1.37931 10.6896V10.8234L1.38483 10.8896C1.43824 11.3166 1.5986 11.7232 1.85103 12.0717C2.30069 12.691 3.28 13.4483 5.51724 13.4483C5.76138 13.4483 5.99172 13.4386 6.2069 13.4221V13.4483C6.2069 13.909 6.24828 14.3586 6.3269 14.7959C6.05755 14.8173 5.78744 14.8279 5.51724 14.8276C2.9269 14.8276 1.49241 13.9255 0.735172 12.8841C0.340361 12.339 0.0919861 11.7016 0.0137931 11.0331C0.00692875 10.9703 0.00232808 10.9073 0 10.8441V10.6896C0 10.1409 0.21798 9.61467 0.605986 9.22667C0.993992 8.83866 1.52024 8.62068 2.06897 8.62068ZM20 13.4483C20 15.0944 19.3461 16.6732 18.182 17.8372C17.018 19.0012 15.4393 19.6552 13.7931 19.6552C12.1469 19.6552 10.5682 19.0012 9.40417 17.8372C8.24015 16.6732 7.58621 15.0944 7.58621 13.4483C7.58621 11.8021 8.24015 10.2233 9.40417 9.05933C10.5682 7.89531 12.1469 7.24137 13.7931 7.24137C15.4393 7.24137 17.018 7.89531 18.182 9.05933C19.3461 10.2233 20 11.8021 20 13.4483ZM13.7931 9.99999C13.6102 9.99999 13.4348 10.0726 13.3054 10.202C13.1761 10.3313 13.1034 10.5067 13.1034 10.6896V13.4483C13.1034 13.6312 13.1761 13.8066 13.3054 13.9359C13.4348 14.0653 13.6102 14.1379 13.7931 14.1379C13.976 14.1379 14.1514 14.0653 14.2808 13.9359C14.4101 13.8066 14.4828 13.6312 14.4828 13.4483V10.6896C14.4828 10.5067 14.4101 10.3313 14.2808 10.202C14.1514 10.0726 13.976 9.99999 13.7931 9.99999ZM13.7931 17.069C14.0217 17.069 14.241 16.9781 14.4027 16.8165C14.5643 16.6548 14.6552 16.4355 14.6552 16.2069C14.6552 15.9783 14.5643 15.759 14.4027 15.5973C14.241 15.4356 14.0217 15.3448 13.7931 15.3448C13.5645 15.3448 13.3452 15.4356 13.1835 15.5973C13.0219 15.759 12.931 15.9783 12.931 16.2069C12.931 16.4355 13.0219 16.6548 13.1835 16.8165C13.3452 16.9781 13.5645 17.069 13.7931 17.069Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const InvalidEmailIcon = (props: IconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.1 20.5572L2.3381 1.70001L1.10001 2.93811L2.52858 4.36668C2.24286 4.74763 1.95715 5.22382 1.95715 5.79525V17.2238C1.95715 18.2714 2.81429 19.1286 3.86191 19.1286H17.2905L19.8619 21.7L21.1 20.5572ZM3.86191 17.2238V7.70001L9.19524 11.0333L15.3857 17.2238H3.86191ZM8.81429 5.79525L6.90953 3.89049H19.1C20.1476 3.89049 21.0048 4.74763 21.0048 5.79525V17.2238C21.0048 17.4143 21.0048 17.7 20.9095 17.8905L19.1 16.081V7.70001L13.9571 10.9381L12.8143 9.79525L19.1 5.79525H8.81429Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const SocialErrorIcon = (props: IconProps) => {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13 16.7654C16.771 16.7654 18.657 16.7654 19.828 15.5934C21 14.4224 21 12.5364 21 8.76538C21 4.99438 21 3.10838 19.828 1.93738C18.657 0.765381 16.771 0.765381 13 0.765381H9C5.229 0.765381 3.343 0.765381 2.172 1.93738C1 3.10838 1 4.99438 1 8.76538C1 12.5364 1 14.4224 2.172 15.5934C2.825 16.2474 4.2 15.873 5.5 16"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 16.7654C11.764 16.7654 10.402 17.2654 9.15899 17.9104C7.16099 18.9474 6.16199 19.4664 5.66999 19.1354C5.17799 18.8054 5.18732 18.549 5.37432 16.5L5 16M8.87899 6.64441L11 8.76541M11 8.76541L13.121 10.8864M11 8.76541L13.121 6.64441M11 8.76541L8.87899 10.8864"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export const CheckMarkIcon = (props: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      {...props}
    >
      <path
        d="M5.54994 9.15L14.0249 0.675C14.2249 0.475 14.4583 0.375 14.7249 0.375C14.9916 0.375 15.2249 0.475 15.4249 0.675C15.6249 0.875 15.7249 1.11267 15.7249 1.388C15.7249 1.66333 15.6249 1.90067 15.4249 2.1L6.24994 11.3C6.04994 11.5 5.8166 11.6 5.54994 11.6C5.28327 11.6 5.04994 11.5 4.84994 11.3L0.549936 7C0.349936 6.8 0.253936 6.56267 0.261936 6.288C0.269936 6.01333 0.374269 5.77567 0.574936 5.575C0.775603 5.37433 1.01327 5.27433 1.28794 5.275C1.5626 5.27567 1.79994 5.37567 1.99994 5.575L5.54994 9.15Z"
        fill="white"
      />
    </svg>
  )
}

export const TimesIcon = (props: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      {...props}
    >
      <path
        d="M7.00005 8.3998L2.10005 13.2998C1.91672 13.4831 1.68338 13.5748 1.40005 13.5748C1.11672 13.5748 0.883382 13.4831 0.700048 13.2998C0.516715 13.1165 0.425049 12.8831 0.425049 12.5998C0.425049 12.3165 0.516715 12.0831 0.700048 11.8998L5.60005 6.9998L0.700048 2.0998C0.516715 1.91647 0.425049 1.68314 0.425049 1.3998C0.425049 1.11647 0.516715 0.883138 0.700048 0.699804C0.883382 0.516471 1.11672 0.424805 1.40005 0.424805C1.68338 0.424805 1.91672 0.516471 2.10005 0.699804L7.00005 5.5998L11.9 0.699804C12.0834 0.516471 12.3167 0.424805 12.6 0.424805C12.8834 0.424805 13.1167 0.516471 13.3 0.699804C13.4834 0.883138 13.575 1.11647 13.575 1.3998C13.575 1.68314 13.4834 1.91647 13.3 2.0998L8.40005 6.9998L13.3 11.8998C13.4834 12.0831 13.575 12.3165 13.575 12.5998C13.575 12.8831 13.4834 13.1165 13.3 13.2998C13.1167 13.4831 12.8834 13.5748 12.6 13.5748C12.3167 13.5748 12.0834 13.4831 11.9 13.2998L7.00005 8.3998Z"
        fill="white"
      />
    </svg>
  )
}
